export const chargeFieldConfiguration = [
  {
    name: "driverId",
    label: "Driver",
    type: "combo",
    dataKey: "drivers",
  },
  {
    name: "ownerCompanyId",
    label: "Company",
    type: "combo",
    dataKey: "ownerCompanies",
  },
  {
    name: "reason",
    label: "Reason",
    type: "text",
    validation: {
      required: "Reason is required",
      minLength: {
        value: 3,
        message: "Reason must be at least 3 characters long",
      },
      maxLength: {
        value: 200,
        message: "Reason must not exceed 200 characters",
      },
    },
  },
  {
    name: "caseNumber",
    label: "Case Number",
    type: "text",
    validation: {
      required: "Case Number is required",
      maxLength: {
        value: 50,
        message: "Case Number must not exceed 50 characters",
      },
    },
  },
  {
    name: "dateCommited",
    label: "Date Commited",
    type: "date",
    validation: {
      required: "Date Commited is required",
    },
  },
  {
    name: "amount",
    label: "Amount",
    type: "decimal",
    validation: {
      required: "Amount is required",
      pattern: {
        value: /^\d+(\.\d{1,2})?$/,
        message: "Amount must be a valid number with up to 2 decimals",
      },
    },
  },
  {
    name: "notes",
    label: "Notes",
    type: "text",
  },
];

export const chargeInitialValues = {
  driverId: "",
  ownerCompanyId: "",
  reason: "",
  caseNumber: "",
  dateCommited: "",
  isCharged: "",
  amount: "",
  notes: "",
};
